import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import { Type, IconCheck } from '@spotify-internal/encore-creator-web';
import { gray90 } from '@spotify-internal/encore-foundation';

const Container = styled.div<{ selected: boolean }>`
  align-items: center;
  background: white;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  color: #bdbdbd;
  display: flex;
  margin: 0 16px 16px 0;
  padding: 10px 16px;
  min-width: min-content;

  &:hover {
    color: black;
    border-color: black;
  }
  ${props =>
    props.selected &&
    css`
      background: black;
      border-color: black;
      color: ${gray90};

      &:hover {
        color: ${gray90};
      }
    `};
`;

const CategoryName = styled(Type.p)`
  margin-right: 20px;
`;

interface Props {
  selected: boolean;
  name: string;
  onClick(): void;
}

export class Subcategory extends PureComponent<Props> {
  render() {
    const { selected, name, onClick } = this.props;
    return (
      <Container selected={selected} onClick={onClick} data-qa="subcategory">
        <CategoryName variant={Type.body2} condensed data-qa="subcategory-name">
          {name}
        </CategoryName>
        <IconCheck iconSize={16} color={selected ? 'gray75' : 'white'} />
      </Container>
    );
  }
}
